import { colors, Modal, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import React from "react";
import { RoomParty, RoomPartyMember } from "../../../graphql/groups.datatypes";
import RoomPartyMemberChangeRoom from "./RoomPartyMemberChangeRoom";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: "90%",
        overflowY: "auto",
        maxWidth: "95%"
    },
    container: {
        marginTop: theme.spacing(3)
    },
    actions: {
        justifyContent: "flex-end"
    },
    deleteButton: {
        color: theme.palette.white,
        backgroundColor: colors.red[600],
        "&:hover": {
            backgroundColor: colors.red[900]
        }
    },
    submitButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        "&:hover": {
            backgroundColor: colors.green[900]
        }
    }
}));

const RoomPartyMemberChangeRoomModal = (props: {
    className?: string;
    onClose: () => void;
    onUpdate?: () => void;
    open: boolean;
    roomParty: RoomParty;
    roomPartyMember: RoomPartyMember;
    setSelectedRoomGuest: (member: RoomPartyMember | null) => void;
    setSelectedModal: (modelSelection: string) => void;
}) => {
    const {
        open,
        onClose,
        onUpdate,
        roomParty,
        roomPartyMember,
        setSelectedRoomGuest,
        setSelectedModal,
        ...rest
    } = props;
    const classes = useStyles();

    if (!open) {
        return null;
    }

    return (
        <Modal onClose={onClose} open={open}>
            <RoomPartyMemberChangeRoom
                className={clsx(classes.root)}
                roomParty={roomParty}
                roomPartyMember={roomPartyMember}
                setSelectedRoomGuest={setSelectedRoomGuest}
                setSelectedModal={setSelectedModal}
            />
        </Modal>
    );
};

export default RoomPartyMemberChangeRoomModal;
